export const SUPERADMIN_ROLE = 'super_admin' as const;

export function isSuperadminRole(role: string | null | undefined): boolean {
  return role === SUPERADMIN_ROLE;
}
